import { useEffect, useState } from "react";

type IndicateServiceNeedName = {
  name: string | null;
  setisIndicateServiceNeedName: React.Dispatch<React.SetStateAction<boolean>>;
}

function IndicateServiceNeedName(props: IndicateServiceNeedName) {
  const { name, setisIndicateServiceNeedName } = props;
  const [serviceNeedNameFormated, setServiceNeedNameFormated] = useState<string | null>();
  const [isShowServiceNeedName, setiShowServiceNeedName] = useState<boolean>(false);

  const formatServiceName = (name: string) => {
    const formatted = name.replace(/_/g, " ").toLowerCase();
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  const closeModal = () => {
    setiShowServiceNeedName(false); // Ferme la fenêtre modale
    setisIndicateServiceNeedName(false);
  };

  const handleIndicateServNeedName = (serviceOrNeeedName: string) => {
    setServiceNeedNameFormated(formatServiceName(serviceOrNeeedName));
    setiShowServiceNeedName(true); // Ouvre la fenêtre modale
  };

  useEffect(() => {
    name ? handleIndicateServNeedName(name) : null;

    const timeoutId = setTimeout(() => {
      closeModal();
    }, 5000);

    return () => {
      clearTimeout(timeoutId); // Nettoyage du timeout
    };
  }, [])
  if (isShowServiceNeedName) {
    return (
      <>
        <div className="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 transition-opacity duration-300"
          onClick={closeModal}
        >
          <div className="modal-content bg-white p-8 rounded-xl shadow-lg transform transition-all duration-300 scale-90 hover:scale-100"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-2xl font-semibold text-gray-800">{serviceNeedNameFormated}</h3>
            <button className="mt-4 px-6 py-2 bg-orangeCustom text-white rounded-full hover:bg-lightRedCustom transition-all"
              onClick={closeModal}
            >
              Fermer
            </button>
          </div>
        </div>
      </>
    )
  } else {
    return null;
  }
}
export default IndicateServiceNeedName;